import { CardElement, useStripe, useElements } from '@stripe/react-stripe-js'
import { useTranslation } from 'react-i18next'

interface CardPaymentFormProps {
  onToken: (token: string) => void
  disabled?: boolean
}

const CARD_ELEMENT_OPTIONS = {
  style: {
    base: {
      fontSize: '14px',
      fontFamily: '"Inter", system-ui, sans-serif',
      color: '#1a1a2e',
      '::placeholder': { color: '#9ca3af' },
    },
    invalid: {
      color: '#ef4444',
      iconColor: '#ef4444',
    },
  },
  hidePostalCode: true,
}

export function CardInputPlaceholder({ onToken, disabled = false }: CardPaymentFormProps) {
  const { t } = useTranslation()
  const stripe = useStripe()
  const elements = useElements()

  const handleChange = async () => {
    if (!stripe || !elements) return
    const cardEl = elements.getElement(CardElement)
    if (!cardEl) return

    const { token, error } = await stripe.createToken(cardEl)
    if (token) onToken(token.id)
    if (error) onToken('')
  }

  return (
    <div className="rounded-md border border-surface-200 bg-white p-4">
      <p className="mb-3 text-xs text-neutral-500">
        Paiement sécurisé via{' '}
        <span className="font-semibold text-[#635bff]">Stripe</span>
      </p>
      <div
        className="rounded-md border border-surface-200 bg-surface-50 px-3 py-3 focus-within:border-primary-500 focus-within:ring-2 focus-within:ring-primary-500"
        aria-label={t('subscription.card_form_label')}
      >
        <CardElement
          options={CARD_ELEMENT_OPTIONS}
          onChange={handleChange}
        />
      </div>
      {disabled && (
        <p className="mt-2 text-xs text-neutral-400">
          {t('subscription.card_hint')}
        </p>
      )}
    </div>
  )
}
